import type { Release } from '../releases.ts';

export default {
  version: '0.8.0',
  date: '2026-09-29',
  title: 'Scaling and editing',
  summary: [
    'Separate, scalable workers for media processing, transcoding and transfers',
    'Video layers with opacity, size and position',
    'Transitions: cross dissolve, dip to black, wipe and slide',
    'Multicam clips with live angle cutting',
    'Delete sequences',
  ],
  features: [
    'Separate, scalable worker services for media processing, transcoding and transfers, with a Workers view',
    'Video layers with opacity, size and position, alpha-channel video and transparent stills',
    'Transitions (cross dissolve, dip to black, wipe, slide) with a Transition button and drag-to-resize',
    'Multicam clips with live angle cutting',
    'Delete sequences',
  ],
  fixes: [],
} satisfies Release;
